import request from '@/utils/request';
import { loginOrg, loginCompany } from '@/utils/LoginContext';

export async function consumingntc(payload) {
    return request(`/iwms-wms/wms/inner/consumingntc`, {
        method: 'POST',
        body: payload.consumingNtcBillCreation
    });
}

export async function modify(payload) {
    return request(`/iwms-wms/wms/inner/consumingntc/modify`, {
        method: 'POST',
        body: payload.consumingNtcBillCreation
    });
}

export async function page(payload) {
    return request(`/iwms-wms/wms/inner/consumingntc/page`, {
        method: 'POST',
        body: payload.filter
    })
}

export async function saveAndAudit(payload) {
    return request(`/iwms-wms/wms/inner/consumingntc/saveAndAudit`, {
        method: 'POST',
        body: payload.consumingBillCreation
    })
}

export async function audit(payload) {
    return request(`/iwms-wms/wms/inner/consumingntc/${payload.uuid}/audit?version=${payload.version}`, {
        method: 'POST'
    })
}

export async function abort(payload) {
    return request(`/iwms-wms/wms/inner/consumingntc/abort?uuid=${payload.uuid}&version=${payload.version}`, {
        method: 'POST'
    })
}

export async function remove(payload) {
    return request(`/iwms-wms/wms/inner/consumingntc/${payload.uuid}?version=${payload.version}`, {
        method: 'DELETE'
    })
}

export async function getByBillNumber(payload) {
    return request(`/iwms-wms/wms/inner/consumingntc/${payload.billNumber}/get?dcUuid=${loginOrg().uuid}`, {
        method: 'GET'
    })
}

export async function getByUuid(payload) {
    return request(`/iwms-wms/wms/inner/consumingntc/${payload.uuid}`, {
        method: 'GET'
    })
}

export async function upload(payload) {
    return request(`/iwms-wms/wms/inner/consumingntc/${payload.uuid}/upload?version=${payload.version}`, {
        method: 'POST'
    })
}

export async function batchimport(payload) {
    return request(`/iwms-wms/wms/inner/consumingntc/batchimport?companyUuid=${loginCompany().uuid}&dcUuid=${loginOrg().uuid}&fileKey=${payload.fileKey}`, {
        method: 'POST',
        body: payload.consuminger
    })
}

export async function abortConsumingntc(payload) {
    return request(`/iwms-wms/wms/inner/consumingntc/abort?uuid=${payload.uuid}&version=${payload.version}`, {
        method: 'POST',
    })
}
